import { render } from "./ProgressBarComponent.vue?vue&type=template&id=54dd3c60&scoped=true"
import script from "./ProgressBarComponent.vue?vue&type=script&lang=js"
export * from "./ProgressBarComponent.vue?vue&type=script&lang=js"

import "./ProgressBarComponent.vue?vue&type=style&index=0&id=54dd3c60&scoped=true&lang=css"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54dd3c60"]])

export default __exports__